const ApiKeyActions = {
  LOADED: "api-key/loaded",
  UPDATED: "api-key/updated",
  LIST_LOADED: "api-keys/loaded",
  LIST_CHANGED: "api-keys/changed",
};

export default ApiKeyActions;
